import { FC } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { FormTextarea } from 'cng-common/features/form'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'

import styles from './ProductExhibitsEditMode.module.scss'

interface IProductExhibitsEditModeProps {
  exhibits: Nullable<string>
}

export const ProductExhibitsEditMode: FC<IProductExhibitsEditModeProps> = ({ exhibits }) => {
  return (
    <div className={styles.root}>
      <FormTextarea
        rows={8}
        resizable="none"
        defaultValue={exhibits || ''}
        field={partnerBasicInfoFields.exhibits}
        formKey={PARTNER_BASIC_INFO_FORM_KEY}
      />
    </div>
  )
}
